import React from 'react'
import Layout from '../../components/BridgePage/Layout'
import './index.scss'

const About3rdX = () => (
  <Layout>
    <div className='about3rd'>
      <h1 className='3rdTitle'>Privacy Policy</h1>

      <p>Last Updated: April 10, 2025</p>
      <p>Previous Version: November 15, 2024</p>
      <p>Introduction</p>
      <p>
        Welcome to Haza Platform (hereinafter referred to as 'Haza'). Haza is provided and controlled by Taala PTE LTD. We respect and protect the personal information and privacy of all Haza users in accordance with the applicable privacy laws worldwide.
      </p>

      <h2>List of Third-party SDK</h2>
      <p>
        Latest Effective Date: April 10, 2025<br />
        In the course of providing services to users, Haza Lite integrates the following third-party SDK technologies. When accessing third-party webpages or using applications developed by third parties, these entities may employ their own cookies or other technical methods. Such technologies are beyond our control and are not governed by this policy. For optimal information security, we recommend that you review the privacy terms of any third-party SDK before utilizing their services. To safeguard your legitimate rights and interests, if you identify any risks associated with these SDKs or similar applications, we advise you to cease related operations and contact us promptly.
      </p>
      <p>
        To enhance service offerings, optimize stability, improve quality, or upgrade functionalities, we may modify the third-party SDKs we integrate and update the SDK directory accordingly. In compliance with applicable laws, regulations, and regulatory requirements, we evaluate the legality, legitimacy, and necessity of third-party SDKs that collect your personal information prior to integration to ensure the protection of your data. You can access each third party's data usage and protection rules through the relevant links. Note that third-party SDKs may update their data processing practices due to version upgrades, policy changes, or other adjustments. Please refer to their official documentation for details.
      </p>

      <h3>SDK Name: “Shengwang” SDK</h3>
      <p>
        <strong>Service Provider:</strong> Shanghai Zhaoyan Network Technology Co., Ltd.<br />
        <strong>Purpose of Use:</strong> To enable audio and video functionalities.<br />
        <strong>Usage Scenario:</strong> Utilized when users engage in audio and video features such as sending voice or video messages.<br />
        <strong>Sharing Method:</strong> The application initializes the SDK, which calls the system’s APIs through its own logic.<br />
        <strong>Types of Personal Information Collected:</strong><br />
        ● Device Information: Device type, model, CPU information, battery status, operating system details.<br />
        ● Network Information: IP address, network type.<br />
        ● Identifiers: Device identifiers, MAC address, WLAN access points, sender/receiver user IDs.<br />
        ● User Data: User attributes, channel information, usage duration, in-channel settings, logs, and content transmitted (text, audio, or other media).<br />
        <strong>Client Platform:</strong> Android<br />
        <p><strong>Privacy Policy Link:</strong> <a href="https://www.agora.io/en/privacy-policy/" target="_blank" rel="noreferrer">https://www.agora.io/en/privacy-policy/</a></p>
      </p>

      <h3>SDK Name: Google SDK</h3>
      <p>
        <strong>Service Provider:</strong> Google Inc.<br />
        <strong>Purpose of Use:</strong> To enable Google Pay and third-party login functionality.<br />
        <strong>Usage Scenario:</strong> Utilized as a login method on the login page.<br />
        <strong>Sharing Method:</strong> The application initializes the SDK, which calls the system’s APIs through its own logic.<br />
        <strong>Types of Personal Information Collected:</strong> None<br />
        <strong>Client Platform:</strong> Android<br />
        <strong>Privacy Policy Link:</strong> <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">https://policies.google.com/privacy</a>
      </p>

      <h3>SDK Name: Firebase SDK</h3>
      <p>
        <strong>Service Provider:</strong> Google Inc.<br />
        <strong>Purpose of Use:</strong> To collect crash reports for stability monitoring.<br />
        <strong>Usage Scenario:</strong> Utilized when the application experiences unexpected crashes.<br />
        <strong>Sharing Method:</strong> The application initializes the SDK, which calls the system’s APIs through its own logic.<br />
        <strong>Types of Personal Information Collected:</strong> None<br />
        <strong>Client Platform:</strong> Android<br />
        <strong>Privacy Policy Link:</strong> <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">https://policies.google.com/privacy</a>
      </p>

      <h3>SDK Name: Facebook SDK</h3>
      <p>
        <strong>Service Provider:</strong> Meta Platforms, Inc.<br />
        <strong>Purpose of Use:</strong> To enable Facebook login functionality.<br />
        <strong>Usage Scenario:</strong> Utilized as a third-party login method on the login page.<br />
        <strong>Sharing Method:</strong> The application initializes the SDK, which calls the system’s APIs through its own logic.<br />
        <strong>Types of Personal Information Collected:</strong> None<br />
        <strong>Client Platform:</strong> Android<br />
        <strong>Privacy Policy Link:</strong> <a href="https://www.facebook.com/privacy/policy/?entry_point=data_policy_redirect&entry=0" target="_blank" rel="noopener noreferrer">https://www.facebook.com/privacy/policy/?entry_point=data_policy_redirect&entry=0</a>
      </p>

      <h3>SDK Name: “Tencent Cloud IM” SDK</h3>
      <p>
        <strong>Service Provider:</strong> Tencent Cloud International Pte. Ltd.<br />
        <strong>Purpose of Use:</strong> To enable instant messaging functionalities.<br />
        <strong>Usage Scenario:</strong> Utilized when users send text messages, images, or other types of messages.<br />
        <strong>Sharing Method:</strong> The application initializes the SDK, which calls the system’s APIs through its own logic.<br />
        <strong>Types of Personal Information Collected:</strong><br />
        ● Device Information: Device type, model, CPU information, battery status, operating system details.<br />
        ● Network Information: IP address, network type.<br />
        ● Identifiers: Device identifiers, WLAN access points, sender/receiver user IDs.<br />
        ● User Data: User attributes, usage duration, logs, and content transmitted (text, images, etc.).<br />
        <strong>Client Platform:</strong> Android<br />
        <strong>Privacy Policy Link:</strong> <a href="https://www.tencentcloud.com/?lang=en&pg=" target="_blank" rel="noopener noreferrer">https://www.tencentcloud.com/?lang=en&pg=</a>
      </p>

      <h3>SDK Name: Adjust SDK</h3>
      <p>
        <strong>Service Provider:</strong> Adjust GmbH<br />
        <strong>Purpose of Use:</strong> For data tracking and analytics purposes.<br />
        <strong>Usage Scenario:</strong> Utilized during user registration and related functional activities.<br />
        <strong>Sharing Method:</strong> The application initializes the SDK, which calls the system’s APIs through its own logic.<br />
        <strong>Types of Personal Information Collected:</strong><br />
        ● Device Information: Device type, model, CPU information, battery status, operating system details.<br />
        ● Network Information: IP address, network type.<br />
        ● Identifiers: Device identifiers, WLAN access points, sender/receiver user IDs.<br />
        ● User Data: User attributes, usage duration, logs.<br />
        <strong>Client Platform:</strong> Android<br />
        <strong>Privacy Policy Link:</strong> <a href="https://www.adjust.com/terms/privacy-policy/" target="_blank" rel="noopener noreferrer">https://www.adjust.com/terms/privacy-policy/</a>
      </p>
    </div>
  </Layout>
)

export default About3rdX
